import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import { motion } from "framer-motion";
import { Mail, Send, Phone, ArrowRight, CheckCircle } from "lucide-react";
import "../styles/theme.css";

export default function Contact() {
  // Integrated your specific Formspree ID: mlgnnjgz
  const [state, handleSubmit] = useForm("mdazzepg");

  // Success State View
  if (state.succeeded) {
    return (
      <main className="page contact-page">
        <section className="contact-hero">
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="form-wrapper glass"
            style={{ textAlign: 'center', padding: '60px 20px' }}
          >
            <CheckCircle size={60} color="#00C9A7" style={{ margin: '0 auto 20px' }} />
            <h1>Message Sent!</h1>
            <p style={{ marginBottom: '30px', color: 'rgba(255,255,255,0.7)' }}>
              Thanks for reaching out, Israel. I've received your message and will get back to you shortly.
            </p>
            <button 
              className="btn primary" 
              onClick={() => window.location.reload()}
            >
              Send another message
            </button>
          </motion.div>
        </section>
      </main>
    );
  }

  return (
    <main className="page contact-page">
      <section className="contact-hero">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="section-header"
        >
          <div className="accent-badge">Get in Touch</div>
          <h1>Let's Build <span style={{color: "#7897db"}}>Something </span>Great</h1>
          <p>
            Have a project in mind? I bridge the gap 
            between <b>design</b> and <b>engineering</b> to bring your ideas to life.
          </p>
        </motion.div>

        <div className="contact-container">
          {/* Contact Info Cards */}
          <div className="contact-info">
            <motion.div 
              className="contact-card glass"
              whileHover={{ y: -5 }}
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <div className="card-icon-wrapper">
                <Mail className="accent-icon" />
              </div>
              <div className="card-text">
                <h3>Email Me</h3>
                <p>bookmrisrael@gmail.com</p>
                <a href="mailto:bookmrisrael@gmail.com" className="contact-action-link">
                  Send a message <ArrowRight size={16} />
                </a>
              </div>
            </motion.div>

            <motion.div 
              className="contact-card glass"
              whileHover={{ y: -5 }}
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.1 }}
            >
              <div className="card-icon-wrapper">
                <Phone className="accent-icon" />
              </div>
              <div className="card-text">
                <h3>WhatsApp</h3>
                <p>+234 702 679 9440</p>
                <a 
                  href="https://wa.me/2347026799440" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="contact-action-link"
                >
                  Chat now <ArrowRight size={16} />
                </a>
              </div>
            </motion.div>
          </div>

          {/* Contact Form */}
          <motion.div 
            className="form-wrapper glass"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
          >
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="full-name">Full Name</label>
                  <input 
                    id="full-name" 
                    type="text" 
                    name="name" 
                    placeholder="John Doe" 
                    required 
                  />
                  <ValidationError prefix="Name" field="name" errors={state.errors} />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input 
                    id="email" 
                    type="email" 
                    name="email" 
                    placeholder="email@example.com" 
                    required 
                  />
                  <ValidationError prefix="Email" field="email" errors={state.errors} />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="message">Project Details</label>
                <textarea 
                  id="message" 
                  name="message" 
                  placeholder="Tell me about what you're building..." 
                  rows="6" 
                  required
                ></textarea>
                <ValidationError prefix="Message" field="message" errors={state.errors} />
              </div>
              <button 
                type="submit" 
                className={`btn primary flex-btn submit-btn ${state.submitting ? 'loading' : ''}`}
                disabled={state.submitting}
              >
                {state.submitting ? "Sending..." : "Send Message"} 
                <Send size={18} />
              </button>
            </form>
          </motion.div>
        </div>
      </section>
    </main>
  );
}